import { Injectable } from "@angular/core";

import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { DffError } from "@dffedb/util";

import { IEjendomsoplysning } from "./ejendomsoplysning.model";
import { EjendomsoplysningerRepository } from "./ejendomsoplysninger.repository";

@Injectable({ providedIn: "root" })
export class EjendomService {
    constructor(private readonly ejendomsoplysningerRepository: EjendomsoplysningerRepository) {}

    public hentEjendomsoplysninger(): Observable<IEjendomsoplysning[]> {
        return this.ejendomsoplysningerRepository.hentEjendomsoplysninger().pipe(
            catchError((e: any) =>
                throwError(
                    new DffError(e.message, {
                        friendlyMessage: "Fejl i hent ejendomsoplysninger.",
                        innerError: e,
                        showNotification: true
                    })
                )
            )
        );
    }
}
